import { Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const MaintenancePaper = withStyles({
  root: {
    borderRadius: 5,
    margin: '20px 20px 60px',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'calc(100% - 40px)',
    boxShadow: `1px 5px 5px 0 ${colors.custom.gray20}`,
    backgroundColor: colors.white,
  },
})(Paper);
